import { Fragment } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { useCourseBySlug } from 'libs/client/api'
import { SubsectionEntities } from 'libs/utils'
import { Article } from 'types/data'
import { ArticleSubsections } from 'types/data/Article'
import FeaturedCourseTrailer from '../FeaturedCourseTrailer'
import Content from './Content'

interface SubsectionsProps {
  subsections: ArticleSubsections[]
}

const Subsections = ({ subsections }: SubsectionsProps) => {
  const { article } = useStaticData<{ article: Article }>()
  const { courseBySlug, error } = useCourseBySlug(article.featuredCourseSlug)

  return (
    <section>
      {subsections
        .filter(
          (subsection) =>
            subsection.entityType === SubsectionEntities.subsection,
        )
        .map((subsection, index) => (
          <Fragment key={subsection.id}>
            <Content subsection={subsection} />
            {index === 0 &&
              !(subsection.videoId || subsection.mediaUuid) &&
              courseBySlug &&
              !error && <FeaturedCourseTrailer />}
          </Fragment>
        ))}
    </section>
  )
}

export default Subsections
